import React from "react";

export function ErrorForm({ message }) {
  return (
    <p
      style={{
        fontSize: "11px", // menor um pouco
        color: "var(--danger)",
        minHeight: "0.9rem", // suficiente pro texto em uma linha
        marginTop: "2px", // bem colado no input
        visibility: message ? "visible" : "hidden",
      }}
    >
      {message || "⠀"} {/* caracter invisível */}
    </p>
  );
}
